module.exports = __webpack_public_path__ + "static/media/header-checkerboard-background-checks.a5b0c665.svg";